// extracted by mini-css-extract-plugin
export default {"dash__header__container":"DashLayoutHeader_dash__header__container__0O6vS"};